// mutates the array with the item inserted at the specified index if the condition is true
export const insertIf = <T>(
  array: T[],
  condition: boolean,
  element: T,
  index: number
): T[] => {
  if (!condition) {
    return array;
  }
  if (index < 0) {
    throw new Error(`insertIf error: Index ${index} out of bounds`);
  }
  array.splice(index, 0, element);
  return array;
};
